import { OnboardingV1OnboardingSurveyRole as SurveyRole } from '@spotify/confidence-graphql';

export type SurveyAnswers = {
  role?: SurveyRole;
  customRole?: string;
};

export const SURVEY_ROLE_OPTIONS: ReadonlyArray<{
  value: SurveyRole;
  label: string;
}> = [
  { value: SurveyRole.Engineering, label: 'Engineering' },
  { value: SurveyRole.DataAnalytics, label: 'Data and analytics' },
  { value: SurveyRole.ProductManagement, label: 'Product management' },
  { value: SurveyRole.DesignResearch, label: 'Design and research' },
  { value: SurveyRole.GrowthMarketing, label: 'Growth and marketing' },
  { value: SurveyRole.FounderExecutive, label: 'Founder or executive' },
];

export const MAX_CUSTOM_ROLE_LENGTH = 100;
